import { Content } from 'src/contexts/ContentContext';
import { vars } from 'src/core/themes';
import { DividerLine, Stack } from 'src/core/ui';
import { ShieldCheckSolidIcon } from 'src/svgs/ShieldCheckSolidIcon';
import { ContentId } from 'src/utils/constants/contentId';

import * as styles from './CampaignModal.css';

export const CampaignModalFooter = () => {
  return (
    <Stack
      className={styles.sellOutProtectionBox}
      alignItems="center"
      gap="l"
      width="full"
    >
      <ShieldCheckSolidIcon size={vars.iconSize.xl} />
      <DividerLine vertical={true} />
      <Content id={ContentId.CampaignSellOutProtectionInfo} />
    </Stack>
  );
};
